import React,{useState} from 'react';
import '../Styles/Blogs.css'

const BlogCard = ({blog}) => {
    const [showBlogMore,setShowBlogMore]= useState(false);

  return (
    <div class="card" style={{ width: "24rem" }}>
            <img src={blog.img} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">{blog.title}</h5>
              <p class="card-text dark-blue">
               {showBlogMore?blog.text:blog.text.slice(0,300)}
              </p>
              <button  onClick={()=>setShowBlogMore(!showBlogMore)} className='read-more'>
               {showBlogMore?'Read Less':'Read More'}
              </button>
            </div>
          </div>
  )
}

export default BlogCard;